import type { SoundName } from '@/lib/sfx';

export type FeedbackKind = 'payment' | 'contribution' | 'import' | 'milestone';

export interface ActionFeedbackMeta extends Record<string, unknown> {
  celebrate?: boolean | 'paid' | 'settled';
  feedback?: FeedbackKind;
}

declare module '@tanstack/react-query' {
  interface Register {
    mutationMeta: ActionFeedbackMeta;
  }
}

export interface CelebrationDetail {
  kind: FeedbackKind;
  sound: SoundName;
  style?: unknown;
}

const FEEDBACK_SOUNDS: Record<FeedbackKind, SoundName> = {
  payment: 'payment',
  contribution: 'contribution',
  import: 'import-complete',
  milestone: 'celebrate',
};

/** Explicit successful financial actions only; never infer importance from toast text. */
export function shouldCelebrate(meta: ActionFeedbackMeta | undefined, variables: unknown) {
  if (meta?.['celebrate'] === true) return true;
  if (meta?.['celebrate'] === 'settled')
    return (
      !!variables &&
      typeof variables === 'object' &&
      'status' in variables &&
      (variables.status === 'settled' || variables.status === 'closed')
    );
  return (
    meta?.['celebrate'] === 'paid' &&
    !!variables &&
    typeof variables === 'object' &&
    'status' in variables &&
    variables.status === 'paid'
  );
}
export function feedbackKindFor(meta?: ActionFeedbackMeta): FeedbackKind {
  return meta?.feedback ?? (meta?.celebrate === 'paid' ? 'payment' : 'milestone');
}

export function celebrateAction(meta?: ActionFeedbackMeta) {
  const kind = feedbackKindFor(meta);
  window.dispatchEvent(
    new CustomEvent<CelebrationDetail>('finbob:celebrate', {
      detail: {
        kind,
        style: meta?.['celebrationStyle'],
        sound:
          kind === 'milestone' && meta?.celebrate === 'settled'
            ? 'close-month'
            : FEEDBACK_SOUNDS[kind],
      },
    }),
  );
}
